// ==============================|| I18N - ESPAÑOL ||============================== //
// Diccionario plano: la clave es la ruta con puntos y el valor el texto final.
// Se mantiene plano a propósito — buscar una clave en el código y encontrarla
// aquí es una sola búsqueda de texto, sin recorrer objetos anidados.
//
// `{{parametro}}` se sustituye al traducir (ver `translate` en ../translate.js).

const pt = {
  'common.save': 'Guardar',
  'common.saving': 'Guardando...',
  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.edit': 'Editar',
  'common.back': 'Volver',
  'common.loading': 'Cargando...',
  'common.actions': 'Acciones',
  'common.status': 'Estado',
  'common.active': 'Activo',
  'common.inactive': 'Inactivo',
  'common.noPermission': 'No tienes permisos para consultar esta información.',
  'common.unexpectedError': 'Ocurrió un error inesperado.',
  'common.all': 'Todos',
  'common.confirm': 'Confirmar',

  'dashboard.title': 'Dashboard',
  'dashboard.totalRoutes': 'Total rutas',
  'dashboard.totalWorkers': 'Total trabajadores',
  'dashboard.totalBoxes': 'Cajas activas',
  'dashboard.totalLoans': 'Préstamos',
  'dashboard.totalCollections': 'Recaudos',
  'dashboard.overview': 'Resumen del negocio',
  'dashboard.uniqueVisitor': 'Visitantes únicos',
  'dashboard.salesReport': 'Reporte de ventas',
  'dashboard.recentOrders': 'Pedidos recientes',
  'dashboard.analyticsReport': 'Reporte analítico',

  'language.label': 'Idioma',
  'language.change': 'Cambiar idioma',

  'routes.title': 'Rutas',
  'routes.create': 'Crear ruta',
  'routes.creating': 'Guardando ruta...',
  'routes.edit': 'Editar ruta',
  'routes.backToList': 'Volver al listado de rutas',
  'routes.id': 'ID consecutivo',
  'routes.idHelp': 'Lo genera el sistema al crear la ruta.',
  'routes.idPlaceholder': 'Se asigna al guardar',
  'routes.name': 'Nombre',
  'routes.description': 'Descripción',
  'routes.number': 'Número de ruta',
  'routes.country': 'País',
  'routes.state': 'Departamento / Estado',
  'routes.city': 'Ciudad',
  'routes.currency': 'Moneda',
  'routes.currencyUnavailable': 'El catálogo todavía no informa la moneda de este país.',
  'routes.currencyFromCountry': 'La moneda la determina el país seleccionado.',
  'routes.location': 'Ubicación',
  'routes.initialValue': 'Valor inicial',
  'routes.maxSale': 'Venta máxima',
  'routes.expenses': 'Gastos',
  'routes.workingDays': 'Días de trabajo',
  'routes.frequency': 'Frecuencia de cobro',
  'routes.automaticOpening': 'Apertura automática de caja',
  'routes.automaticOpeningOn': 'La caja se abrirá automáticamente en los días de trabajo seleccionados.',
  'routes.automaticOpeningNeedsDays': 'Selecciona al menos un día de trabajo para habilitar la apertura automática.',
  'routes.cashOpening': 'Apertura de caja',
  'routes.cashOpeningAutomatic': 'Automática',
  'routes.cashOpeningManual': 'Manual',
  'routes.collector': 'Cobrador',
  'routes.collectorUnassigned': 'Sin asignar',
  'routes.collectorManagedElsewhere': 'La asignación de trabajadores se gestiona desde Gestión de trabajadores.',
  'routes.users': 'Usuarios que pueden ver la ruta',
  'routes.usersEmpty': 'Esta ruta no tiene usuarios autorizados.',
  'routes.usersHidden': 'Esta ruta tiene {{count}} usuario(s) autorizado(s).',
  'routes.usersSearch': 'Buscar usuario...',
  'routes.usersNotFound': 'Usuario no encontrado',
  'routes.usersLoadError': 'No se pudo cargar el catálogo de usuarios',
  'routes.usersLoading': 'Cargando usuarios...',
  'routes.sectionInformation': 'Información',
  'routes.sectionPermissions': 'Permisos',
  'routes.sectionDaysAndFrequency': 'Días de trabajo y frecuencia',
  'routes.sectionCashAndCollection': 'Configuración de caja y cobro',
  'routes.clients': 'Clientes de la ruta',
  'routes.clientsAdd': 'Agregar clientes',
  'routes.clientsEmpty': 'Esta ruta todavía no tiene clientes asignados.',
  'routes.listEmpty': 'No hay rutas que coincidan con el filtro.',
  'routes.allCollectors': 'Todos los cobradores',
  'routes.allStatuses': 'Todos los estados',
  'routes.created': 'Ruta "{{nombre}}" creada correctamente con el consecutivo {{consecutivo}}.',
  'routes.deactivate': 'Desactivar ruta',
  'routes.deactivateConfirm': '¿Desactivar la ruta "{{nombre}}"?',
  'routes.deactivateAction': 'Desactivar',
  'routes.removeClient': 'Quitar cliente de la ruta',
  'routes.removeClientConfirm': '¿Quitar a {{nombre}} de esta ruta?',
  'routes.removeClientAction': 'Quitar',
  'routes.removeClientTooltip': 'Quitar de la ruta',
  'routes.viewDetail': 'Ver detalle',
  'routes.createError': 'No se pudo crear la ruta.',
  'routes.createForbidden': 'No tienes permisos para crear rutas.',
  'routes.updateForbidden': 'No tienes permisos para editar rutas.',
  'routes.updateError': 'No se pudo guardar la ruta.',

  'routes.validation.name': 'El nombre es obligatorio',
  'routes.validation.number': 'El número de ruta es obligatorio y debe ser numérico',
  'routes.validation.initialValue': 'El valor inicial es obligatorio y debe ser numérico',
  'routes.validation.users': 'Selecciona al menos un usuario que pueda ver la ruta',
  'routes.validation.country': 'El país es obligatorio',
  'routes.validation.state': 'El departamento es obligatorio',
  'routes.validation.city': 'La ciudad es obligatoria',
  'routes.validation.maxSale': 'La venta máxima es obligatoria y debe ser numérica',
  'routes.validation.expenses': 'El valor de gastos es obligatorio y debe ser numérico',
  'routes.validation.workingDays': 'Selecciona al menos un día de trabajo',
  'routes.validation.automaticOpening': 'La apertura automática de caja requiere al menos un día de trabajo',
  'routes.validation.frequency': 'La frecuencia de cobro es obligatoria',

  'routes.edit.lockedBySales': 'No se puede modificar porque la ruta ya tiene ventas registradas.',
  'routes.edit.lockedByContract': 'Este campo todavía no se puede modificar desde esta pantalla.',
  'routes.edit.lockedNotice': 'Los campos deshabilitados conservan su valor actual: se muestran para consulta y no se envían al guardar.',

  'location.selectCountry': 'Seleccione un país',
  'location.selectState': 'Seleccione un departamento',
  'location.selectCity': 'Seleccione una ciudad',
  'location.selectCountryFirst': 'Seleccione primero un país',
  'location.selectStateFirst': 'Seleccione primero un departamento',
  'location.loadingCountries': 'Cargando países...',
  'location.loadingStates': 'Cargando departamentos...',
  'location.loadingCities': 'Cargando ciudades...',
  'location.countriesError': 'No se pudo cargar el listado de países.',
  'location.statesError': 'No se pudo cargar el listado de departamentos.',
  'location.citiesError': 'No se pudo cargar el listado de ciudades.',
  'location.countriesEmpty': 'El catálogo de países está vacío.',
  'location.statesEmpty': 'Este país todavía no tiene departamentos cargados.',
  'location.citiesEmpty': 'Este departamento todavía no tiene ciudades cargadas.',

  'cash.title': 'Caja',
  'cash.name': 'Caja',
  'cash.businessDate': 'Fecha de negocio',
  'cash.openingDate': 'Fecha de apertura',
  'cash.route': 'Ruta',
  'cash.worker': 'Trabalhador',
  'cash.selectRoute': 'Selecciona una ruta',
  'cash.selectRouteFirst': 'Selecciona una ruta para consultar sus cajas.',
  'cash.empty': 'No hay cajas para esta ruta.',
  'cash.open': 'Abrir nueva caja',
  'cash.openAction': 'Abrir caja',
  'cash.initialAmount': 'Valor inicial',
  'cash.initialAmountCarryOver': 'É o saldo com que fechou o último caixa desta rota.',
  'cash.initialAmountRouteDefault': 'É o valor inicial configurado para esta rota: ainda não teve nenhum caixa.',
  'cash.columnInitialAmount': 'Valor inicial',
  'cash.columnClosingAmount': 'Valor de fechamento',
  'cash.noWorker': 'Esta rota não tem um cobrador designado: não é possível abrir um caixa sem saber para quem.',
  'cash.incident': 'Incidencia',
  'cash.statusOpen': 'Abierta',
  'cash.statusClosed': 'Cerrada',
  'cash.statusForceClosed': 'Cierre forzado',
  'cash.statusUnknown': 'Desconocido',
  'cash.operations': 'Operaciones disponibles',
  'cash.forceClose': 'Cerrar caja mediante cierre forzado',
  'cash.forceCloseDescription': 'Esta caja se cerrará de forma forzada. Es posible que existan movimientos no sincronizados.',
  'cash.forceCloseConfirm': 'Cerrar caja',
  'cash.reopen': 'Reabrir caja',
  'cash.reopenDescription': '¿Reabrir esta caja cerrada forzadamente?',
  'cash.showMore': 'Ver más cajas',

  'installments.mark': 'Marcar cuota',
  'installments.markShort': 'Marcar',
  'installments.markTitle': 'Marcar cuota {{numero}}',
  'installments.client': 'Cliente',
  'installments.number': 'Cuota',
  'installments.dueDate': 'Vencimiento',
  'installments.amount': 'Valor de la cuota',
  'installments.pending': 'Pendiente por pagar',
  'installments.pendingShort': 'Pendiente',
  'installments.amountToRegister': 'Monto a registrar',
  'installments.paymentMethod': 'Método de pago',
  'installments.notes': 'Notas (opcional)',
  'installments.confirmTitle': 'Confirmar marcación de cuota',
  'installments.confirmDescription':
    'Se registrará un pago de {{monto}} sobre esta cuota. La operación afecta el saldo del préstamo y no puede deshacerse.',
  'installments.marking': 'Marcando cuota...',
  'installments.marked': 'Cuota marcada correctamente.',
  'installments.error': 'No se pudo marcar la cuota.',
  'installments.alreadyPaid': 'Esta cuota ya está pagada.',
  'installments.invalidAmount': 'Ingresa un monto mayor que cero y menor o igual al pendiente.',
  'installments.loanNotActive': 'Solo se pueden marcar cuotas de préstamos activos.',

  'days.LUNES': 'Lunes',
  'days.MARTES': 'Martes',
  'days.MIERCOLES': 'Miércoles',
  'days.JUEVES': 'Jueves',
  'days.VIERNES': 'Viernes',
  'days.SABADO': 'Sábado',
  'days.DOMINGO': 'Domingo',

  'frequency.DIARIA': 'Diaria',
  'frequency.SEMANAL': 'Semanal',
  'frequency.QUINCENAL': 'Quincenal',
  'frequency.MENSUAL': 'Mensual',

  'routes.maxSaleHelp':
    'Ingrese el valor máximo de la venta que se permite a la ruta, si se supera este monto se solicita aprobación al administrador/coordinador de la ruta.',
  'routes.expensesHelp':
    'Ingrese el valor máximo de gasto que se permite a la ruta, si se supera este monto se solicita aprobación al administrador/coordinador de la ruta.',

  // Cobro de la plataforma a las unidades (PROP-002). Los textos describen qué
  // mostrará la pantalla y qué falta por definir: ninguno enuncia una regla,
  // un precio, una periodicidad ni un estado concreto, porque nada de eso está
  // definido todavía.
  'platform.title': 'Cobro de la plataforma',
  'platform.description':
    'Facturación del uso de la plataforma a cada unidad. Es un cobro distinto del cobro operativo de cartera a los clientes de la ruta.',
  'platform.pendingNotice':
    'Módulo pendiente de definición de negocio (PROP-002). La pantalla queda preparada, pero no muestra datos: las reglas todavía no están definidas y el backend aún no expone los servicios correspondientes.',
  'platform.pendingValue': 'Pendiente de definición',
  'platform.unit': 'Unidad',
  'platform.sectionUnitBilling': 'Configuración de cobro de la unidad',
  'platform.sectionPeriodicity': 'Periodicidad de facturación',
  'platform.sectionPlan': 'Plan / precio asignado',
  'platform.sectionBillingStatus': 'Estado de facturación y pago',
  'platform.sectionUnitStatus': 'Estado de la unidad',
  'platform.sectionBillingContact': 'Responsable de facturación',
  'platform.sectionPaymentMethod': 'Método de pago',
  'platform.openQuestionsTitle': 'Definiciones pendientes (PROP-002)',
  'platform.openQuestionsIntro': 'Son decisiones de negocio/comercial. Hasta que se tomen, no se construyen las reglas de este módulo.',
  'platform.question1': 'Periodicidad del cobro: con qué frecuencia se factura a cada unidad, y si es igual para todas.',
  'platform.question2': 'Límite de usuarios por unidad, y si el precio depende de esa cantidad o es un valor fijo por unidad.',
  'platform.question3': 'Bloqueo por no pago: desde cuántos días de mora, si es total o parcial, y cómo se reactiva tras el pago.',
  'platform.question4': 'Recordatorios de pago: anticipación, canal y cuántos se envían antes del bloqueo.',
  'platform.question5': 'Qué ocurre con los datos y la cartera de una unidad bloqueada por no pago.',
  'platform.question6': 'Quién recibe la factura por parte de la unidad (rol o contacto responsable del pago).',
  'platform.question7': 'Método de pago del servicio.',

  // Gestion de trabajadores (US-006 crear, US-007 dispositivos, US-008 listado).
  'workers.moduleTitle': 'Gestión de trabajadores',
  'workers.tabCreate': 'Crear nuevo trabajador',
  'workers.tabList': 'Trabajadores',
  'workers.tabDevices': 'Vincular dispositivos',
  'workers.noTabs': 'No tienes permisos para ninguna opción de este módulo.',

  'workers.searchPlaceholder': 'Buscar por nombre, apodo, documento, celular...',
  'workers.allStatuses': 'Todos los estados',
  'workers.statusActive': 'Activo',
  'workers.statusInactive': 'Inactivo',
  'workers.columnPin': 'PIN',
  'workers.columnFullName': 'Nombre completo',
  'workers.columnNickname': 'Apodo',
  'workers.columnPhone': 'Celular',
  'workers.columnUnit': 'Unidad',
  'workers.pinNeverLinked': '— sin vincular —',
  'workers.listEmpty': 'No hay trabajadores que coincidan con la búsqueda.',
  'workers.openActions': 'Acciones del trabajador',
  'workers.actionActivate': 'Activar',
  'workers.actionDeactivate': 'Desactivar',
  'workers.actionChangePassword': 'Alterar senha',
  'workers.deactivateTitle': 'Confirmar desactivación',
  'workers.deactivateConfirm': '¿Desea desactivar a {{nombre}}? Esto libera su unidad y desvincula su dispositivo.',
  'workers.activateError': 'No se pudo activar el trabajador.',
  'workers.deactivateError': 'No se pudo desactivar el trabajador.',

  'workers.createTitle': 'Crear nuevo trabajador',
  'workers.editTitle': 'Editar trabajador',
  'workers.sectionUnit': 'Unidad',
  'workers.unit': 'Unidad',
  'workers.unitHelp': 'Solo unidades sin trabajador asignado y de su perfil.',
  'workers.selectUnit': 'Seleccione unidad',
  'workers.unitsEmpty': 'No hay unidades disponibles para asignar.',
  'workers.sectionPersonal': 'Datos personales',
  'workers.firstName': 'Primer nombre',
  'workers.secondName': 'Segundo nombre',
  'workers.firstSurname': 'Primer apellido',
  'workers.secondSurname': 'Segundo apellido',
  'workers.nickname': 'Apodo',
  'workers.sectionOrigin': 'Origen e identificación',
  'workers.birthCountry': 'País natal',
  'workers.birthState': 'Estado natal',
  'workers.birthCity': 'Ciudad natal',
  'workers.documentType': 'Tipo de documento',
  'workers.selectDocumentType': 'Seleccione tipo de documento',
  'workers.documentTypeHelp': 'La lista depende del país natal e incluye pasaporte.',
  'workers.documentTypeNeedsCountry': 'Seleccione primero el país natal',
  'workers.document': 'Documento',
  'workers.documentHelp': 'Único; la validación depende del tipo elegido.',
  'workers.sectionContact': 'Contacto',
  'workers.email': 'Correo principal',
  'workers.phone': 'Número celular principal',
  'workers.phoneAdditional': 'Celular adicional',
  'workers.addPhone': 'Agregar celular adicional',
  'workers.removePhone': 'Quitar celular',
  'workers.sectionResidence': 'Residencia',
  'workers.residenceCountry': 'País residencia',
  'workers.residenceState': 'Estado residencia',
  'workers.residenceCity': 'Ciudad residencia',
  'workers.address': 'Dirección principal',
  'workers.addressAdditional': 'Dirección adicional',
  'workers.addAddress': 'Agregar dirección adicional',
  'workers.removeAddress': 'Quitar dirección',
  'workers.sectionAccess': 'Acesso',
  'workers.password': 'Senha',
  'workers.passwordHelp': 'Com esta senha o trabalhador inicia sessão. Mínimo de 8 caracteres.',
  'workers.passwordConfirm': 'Confirmar senha',
  'workers.sectionAttachments': 'Adjuntos',
  'workers.attachmentsField': 'Seleccione archivo',
  'workers.attachmentsHelp': 'Aquí puede adjuntar la información del documento de identidad y foto del trabajador',
  'workers.attachmentsFormats': 'Opcional. Imágenes (JPG/PNG) y PDF.',
  'workers.attachmentsInvalidFile': 'Archivo no válido. Use JPG, PNG o PDF.',
  'workers.removeAttachment': 'Quitar adjunto',
  'workers.chooseFiles': 'Elegir archivos',
  'workers.noFileSelected': 'Ningún archivo seleccionado',
  'workers.createError': 'No se pudo crear el trabajador.',
  'workers.updateError': 'No se pudo guardar el trabajador.',
  'workers.created': 'Trabajador creado y vinculado a la unidad.',
  'workers.updated': 'Trabajador actualizado.',

  'workers.validation.unit': 'La unidad es obligatoria',
  'workers.validation.firstName': 'El primer nombre es obligatorio',
  'workers.validation.firstSurname': 'El primer apellido es obligatorio',
  'workers.validation.nickname': 'El apodo es obligatorio',
  'workers.validation.documentType': 'El tipo de documento es obligatorio',
  'workers.validation.document': 'El documento es obligatorio',
  'workers.validation.documentFormat': 'O documento não tem o formato válido para o tipo de documento selecionado',
  'workers.validation.email': 'Ingresa un correo con formato válido',
  'workers.validation.phone': 'El celular principal es obligatorio',
  'workers.validation.residenceCountry': 'El país de residencia es obligatorio',
  'workers.validation.residenceState': 'El estado de residencia es obligatorio',
  'workers.validation.residenceCity': 'La ciudad de residencia es obligatoria',
  'workers.validation.address': 'La dirección principal es obligatoria',
  'workers.validation.password': 'A senha deve ter pelo menos 8 caracteres',
  'workers.validation.passwordConfirm': 'As senhas não coincidem',

  'workers.devicesStep1': 'Paso 1 · Seleccione la unidad',
  'workers.devicesUnitHelp': 'Al seleccionar, se muestra el dispositivo de la unidad o se habilita vincular uno.',
  'workers.devicesSelectUnitFirst': 'Seleccione una unidad para continuar.',
  'workers.deviceCaseA': 'Esta unidad ya tiene un dispositivo vinculado',
  'workers.deviceCaseB': 'Esta unidad no tiene dispositivo vinculado',
  'workers.deviceWorker': 'Trabajador',
  'workers.devicePin': 'PIN dispositivo',
  'workers.deviceStatus': 'Estado',
  'workers.deviceLinkedAt': 'Fecha de vinculación',
  'workers.deviceLinked': 'Vinculado',
  'workers.unlinkReason': 'Motivo desvinculación',
  'workers.selectReason': 'Seleccione motivo',
  'workers.reasonUnitChange': 'Cambio de unidad',
  'workers.reasonDeactivated': 'Desactivado',
  'workers.reasonLostStolen': 'Dispositivo robado o perdido',
  'workers.unlink': 'Desvincular',
  'workers.unlinkTwoSteps': 'Seleccione el motivo (obligatorio) y presione Desvincular; luego confirme en el diálogo.',
  'workers.unlinkConfirmTitle': 'Confirmar desvinculación',
  'workers.unlinkConfirm': '¿Desea desvincular el dispositivo de {{nombre}}?',
  'workers.unlinkReasonLine': 'Motivo: {{motivo}}',
  'workers.unlinkError': 'No se pudo desvincular el dispositivo.',
  'workers.link': 'Vincular',
  'workers.enterPin': 'Ingrese el PIN del dispositivo del trabajador',
  'workers.pinHelp': 'O PIN de 6 dígitos é gerado pelo sistema e exibido no app do trabalhador quando ele entra pelo celular.',
  'workers.linkError': 'No se pudo vincular el dispositivo.',
  'workers.linked': 'Dispositivo vinculado.',
  'workers.unlinked': 'Dispositivo desvinculado.',

  // Registro de actividad / logs (US-009). Pendiente de traducción real al
  // portugués, igual que el resto de este archivo (ver nota de cabecera).
  'activityLog.title': 'Registro de actividad',
  'activityLog.unit': 'Unidad',
  'activityLog.selectUnit': 'Selecciona una unidad',
  'activityLog.noUnits': 'No tienes unidades vinculadas a tu perfil.',
  'activityLog.dateFrom': 'Fecha desde',
  'activityLog.dateTo': 'Fecha hasta',
  'activityLog.search': 'Consultar',
  'activityLog.invalidRange': 'La fecha desde no puede ser posterior a la fecha hasta.',
  'activityLog.emptyState': 'Selecciona una unidad y un rango de fechas para consultar el registro de actividad.',
  'activityLog.noResults': 'No se encontraron registros para los filtros seleccionados.',
  'activityLog.columnDate': 'Fecha y hora',
  'activityLog.columnUser': 'Usuario',
  'activityLog.columnOrigin': 'Origen',
  'activityLog.columnUnit': 'Unidad',
  'activityLog.columnModule': 'Módulo',
  'activityLog.columnEntity': 'Entidad afectada',
  'activityLog.columnProcess': 'Proceso',
  'activityLog.columnDetail': 'Detalle',
  'activityLog.columnBefore': 'Valor anterior',
  'activityLog.columnAfter': 'Valor nuevo',
  'activityLog.noValue': '—',
  'activityLog.filterUser': 'Filtrar por usuario',
  'activityLog.filterOriginAll': 'Todos los orígenes',
  'activityLog.filterModuleAll': 'Todos los módulos',
  'activityLog.filterProcessAll': 'Todos los procesos',
  'activityLog.filterEntity': 'Filtrar por entidad',
  'activityLog.filterDetail': 'Filtrar por detalle',
  'activityLog.clearFilters': 'Limpiar filtros',
  'activityLog.exportExcel': 'Descargar Excel',
  'activityLog.exporting': 'Descargando...',
  'activityLog.originWeb': 'Web',
  'activityLog.originMobile': 'Móvil',
  'activityLog.moduleCaja': 'Caja',
  'activityLog.moduleTrabajadores': 'Trabajadores',
  'activityLog.moduleDispositivos': 'Dispositivos',
  'activityLog.moduleVentas': 'Ventas',
  'activityLog.modulePagos': 'Pagos',
  'activityLog.moduleGastos': 'Gastos',
  'activityLog.moduleIngresos': 'Ingresos',
  'activityLog.moduleClientes': 'Clientes',
  'activityLog.moduleRutas': 'Rutas',
  'activityLog.moduleCargueCartera': 'Cargue de cartera',
  'activityLog.processCreation': 'Creación',
  'activityLog.processModification': 'Modificación',
  'activityLog.processDeletion': 'Eliminación',
  'cash.uploadPortfolio': 'Subir carteira',
  'cartera.title': 'Subir carteira',
  'cartera.route': 'Rota',
  'cartera.back': 'Voltar aos caixas',
  'cartera.intro': 'Carregue em massa a carteira desta rota a partir do modelo. Os clientes carregados ficam vinculados à rota.',
  'cartera.notCashNotice': 'Carregar carteira registra dívida a receber: não é dinheiro recebido e não altera os valores do caixa.',
  'cartera.stepTemplate': 'Passo 1 · Baixe o modelo',
  'cartera.stepFile': 'Passo 2 · Selecione o modelo preenchido',
  'cartera.stepRun': 'Passo 3 · Realize o carregamento',
  'cartera.fieldsTitle': 'Campos do modelo',
  'cartera.fieldsHelp': 'Os campos marcados com * são obrigatórios.',
  'cartera.frequenciesHelp': 'Frequências permitidas: {{frecuencias}}. A data da primeira parcela usa o formato dd/mm/aaaa.',
  'cartera.requiredField': 'obrigatório',
  'cartera.downloadTemplate': 'Baixar modelo',
  'cartera.downloading': 'Baixando...',
  'cartera.downloadError': 'Não foi possível baixar o modelo.',
  'cartera.fileInputLabel': 'Modelo preenchido (.xlsx)',
  'cartera.selectFile': 'Selecionar arquivo',
  'cartera.replaceFile': 'Substituir arquivo',
  'cartera.removeFile': 'Remover arquivo',
  'cartera.noFile': 'Nenhum arquivo selecionado',
  'cartera.fileReady': 'Pronto para carregar',
  'cartera.fileInvalidExtension': 'O arquivo deve ser um modelo do Excel (.xlsx).',
  'cartera.fileEmpty': 'O arquivo está vazio.',
  'cartera.fileTooLarge': 'O arquivo excede o tamanho máximo permitido.',
  'cartera.execute': 'Realizar carregamento',
  'cartera.validate': 'Validar arquivo',
  'cartera.selectFirst': 'Selecione um arquivo para continuar.',
  'cartera.processing': 'Processando o carregamento. Não feche nem recarregue esta página.',
  'cartera.validating': 'Validando o arquivo...',
  'cartera.successTitle': 'Carteira carregada com sucesso',
  'cartera.successDetail':
    'Foram carregados {{clientes}} clientes com sua carteira ({{cuotas}} parcelas). Saldo total a receber: {{saldo}}.',
  'cartera.validTitle': 'O arquivo é válido',
  'cartera.validDetail':
    'Nenhum erro foi encontrado. Ao realizar o carregamento serão criados {{clientes}} clientes com {{cuotas}} parcelas e um saldo a receber de {{saldo}}. Nada foi carregado ainda.',
  'cartera.loadAnother': 'Carregar outro arquivo',
  'cartera.rejectedTitle': 'Arquivo rejeitado: nenhum registro foi carregado',
  'cartera.rejectedDetail':
    'Foram encontrados {{errores}} erros nas {{filas}} linhas lidas. O carregamento é tudo ou nada: enquanto houver um erro nenhum cliente é carregado. Corrija o arquivo no Excel e selecione-o novamente.',
  'cartera.colRow': 'Linha',
  'cartera.colField': 'Campo',
  'cartera.colDescription': 'Descrição',
  'cartera.fileLevel': 'Arquivo',
  'cartera.unexpectedError': 'Não foi possível concluir a operação',
  'cartera.unexpectedErrorDetail': 'Ocorreu um erro inesperado.',
  'cartera.canRetry': 'Nenhum registro foi carregado. Você pode tentar novamente.',
  'cartera.noPermission': 'Você não tem permissão para subir carteira.',
  'cartera.routeNotFound': 'A rota não existe ou não está vinculada ao seu perfil.',
  'profiles.pageTitle': 'Funções e permissões',
  'profiles.tabsLabel': 'Perfis',
  'profiles.tabNew': 'Novo Perfil',
  'profiles.tabList': 'Lista de Perfis',
  'profiles.name': 'Nome do perfil',
  'profiles.namePlaceholder': 'Ex.: Supervisor',
  'profiles.nameRequired': 'O nome do perfil é obrigatório',
  'profiles.nameMin': 'O nome deve ter pelo menos 3 caracteres',
  'profiles.status': 'Estado',
  'profiles.statusActive': 'Ativo',
  'profiles.statusInactive': 'Inativo',
  'profiles.import': 'Deseja importar um perfil?',
  'profiles.importSelect': 'Perfis criados',
  'profiles.importPlaceholder': 'Selecione um perfil',
  'profiles.importLoading': 'Carregando perfis…',
  'profiles.importEmpty': 'Ainda não há perfis criados para importar.',
  'profiles.importError': 'Não foi possível carregar os perfis criados.',
  'profiles.importLoaded': 'Permissões carregadas do perfil «{{nombre}}». Você pode alterá-las antes de salvar.',
  'profiles.importKept': '{{cantidad}} permissões de «{{nombre}}» que esta tabela ainda não detalha serão mantidas ao salvar.',
  'profiles.permissionsTitle': 'Permissões do perfil',
  'profiles.permissionsHelp': 'Defina o que este perfil poderá fazer. São as permissões do perfil que você está criando, não as suas.',
  'profiles.loadingPermissions': 'Carregando permissões…',
  'profiles.permissionsError': 'Não foi possível carregar o catálogo de permissões.',
  'profiles.retry': 'Tentar novamente',
  'profiles.save': 'Salvar Perfil',
  'profiles.saving': 'Salvando…',
  'profiles.saved': 'Perfil «{{nombre}}» criado com sucesso.',
  'profiles.saveError': 'Não foi possível salvar o perfil.',
  'profiles.colPermission': 'Permissão',
  'profiles.tableLabel': 'Permissões por módulo',
  'profiles.level.none': 'Nenhum',
  'profiles.level.read': 'Leitura',
  'profiles.level.full': 'Total',
  'profiles.level.noneHelp': 'sem acesso ao módulo nem à ação.',
  'profiles.level.readHelp': 'pode ver as informações do módulo, sem modificá-las.',
  'profiles.level.fullHelp': 'acesso completo ao módulo, ou pode executar a ação.',
  'profiles.legendTitle': 'Significado dos níveis',
  'profiles.legendActions': 'As ações são operações pontuais: só são permitidas (Total) ou não (Nenhum).',
  'profiles.kind.module': 'Módulo',
  'profiles.kind.action': 'Ação',
  'profiles.onlyActions': 'Só tem ações',
  'profiles.unavailable': 'Indisponível',
  'profiles.unavailableHelp': 'O servidor ainda não tem esta permissão, por isso não pode ser atribuída.',
  'profiles.module.dashboard': 'Dashboard',
  'profiles.module.rutas': 'Rotas',
  'profiles.module.trabajadores': 'Gestão de trabalhadores',
  'profiles.module.caja': 'Caixa',
  'profiles.module.cartera': 'Carga de carteira',
  'profiles.module.logs': 'Registro de atividade (Logs)',
  'profiles.module.roles': 'Funções e permissões',
  'profiles.module.usuarios': 'Usuários',
  'profiles.action.rutas.crear': 'Criar rota',
  'profiles.action.rutas.editar': 'Editar rota',
  'profiles.action.trabajadores.crear': 'Criar trabalhador',
  'profiles.action.trabajadores.dispositivos': 'Vincular / desvincular dispositivos',
  'profiles.action.caja.abrir': 'Abrir caixa',
  'profiles.action.caja.cerrar': 'Fechar caixa',
  'profiles.action.caja.cierre-forzado': 'Fechamento forçado',
  'profiles.action.caja.reabrir': 'Reabrir caixa',
  'profiles.action.caja.operar': 'Confirmar caixa, registrar despesa e registrar receita',
  'profiles.action.cartera.subir': 'Subir carteira',
  'profiles.list.error': 'Não foi possível carregar a lista de perfis.',
  'cartera.selectRoute': 'Selecione uma rota',
  'cartera.selectRouteFirst': 'Selecione a rota para a qual a carteira será carregada.',
  'workers.alertsTitle': 'Solicitações de vinculação pendentes',
  'workers.alertPending': '{{nombre}} ({{unidad}}) entrou de {{equipo}} e aguarda a autorização do PIN.',
  'workers.alertDeviceChange':
    'Alerta! {{nombre}} ({{unidad}}) entrou de um dispositivo diferente: {{equipo}}. {{anterior}} foi desvinculado automaticamente. Peça o PIN exibido no app para vincular o novo.',
  'workers.alertAttend': 'Atender',
  'workers.pendingForUnit': '{{nombre}} aguarda a vinculação de {{equipo}}. Peça o PIN de 6 dígitos exibido no app.',
  'workers.noPendingForUnit': 'O trabalhador ainda não entrou pelo celular: o PIN é gerado nesse momento.',
  'workers.deviceModel': 'Dispositivo',
  'workers.deviceUnknown': 'Dispositivo não identificado',
  'clients.moduleTitle': 'Clientes',
  'clients.tabNew': 'Novo Cliente',
  'clients.tabList': 'Lista de Clientes',
  'clients.newTitle': 'Novo cliente',
  'clients.editTitle': 'Editar cliente',
  'clients.statusEditHint': 'O estado é alterado na lista, com confirmação.',
  'clients.requiredHint': 'Os campos marcados com * são obrigatórios.',
  'clients.route': 'Rota',
  'clients.routePlaceholder': 'Selecione a rota',
  'clients.routeHelp': 'A rota define o país, os tipos de documento e as cidades.',
  'clients.country': 'País da rota: {{pais}}',
  'clients.selectRouteFirst': 'Selecione primeiro uma rota',
  'clients.city': 'Cidade',
  'clients.cityPlaceholder': 'Busque e selecione a cidade',
  'clients.cityNoOptions': 'Nenhuma cidade encontrada',
  'clients.firstName': 'Nome',
  'clients.lastName': 'Sobrenomes',
  'clients.nickname': 'Apelido',
  'clients.email': 'E-mail',
  'clients.documentType': 'Tipo de documento',
  'clients.documentTypePlaceholder': 'Selecione o tipo',
  'clients.documentNumber': 'Número do documento',
  'clients.birthDate': 'Data de nascimento',
  'clients.address': 'Endereço',
  'clients.neighborhood': 'Bairro',
  'clients.phone': 'Celular',
  'clients.phone2': 'Celular 2',
  'clients.comment': 'Comentário',
  'clients.activity': 'Atividade econômica',
  'clients.activityNone': 'Sem atividade',
  'clients.activityEmpty': 'Ainda não há atividades econômicas disponíveis.',
  'clients.retry': 'Tentar novamente',
  'clients.catalogsError': 'Não foi possível carregar as opções da rota.',
  'clients.routesError': 'Não foi possível carregar suas rotas.',
  'clients.noRoutes': 'Seu perfil não tem rotas vinculadas: não há clientes para gerenciar.',
  'clients.loadingClient': 'Carregando cliente…',
  'clients.clientNotFound': 'O cliente não existe ou não é do seu perfil.',
  'clients.backToList': 'Voltar à lista',
  'clients.created': 'Cliente «{{nombre}}» criado com sucesso.',
  'clients.updated': 'Cliente «{{nombre}}» atualizado com sucesso.',
  'clients.saveError': 'Não foi possível salvar o cliente.',
  'clients.validation.route': 'A rota é obrigatória',
  'clients.validation.firstName': 'O nome é obrigatório',
  'clients.validation.lastName': 'Os sobrenomes são obrigatórios',
  'clients.validation.nickname': 'O apelido é obrigatório',
  'clients.validation.emailFormat': 'O e-mail não tem um formato válido',
  'clients.validation.documentType': 'O tipo de documento é obrigatório',
  'clients.validation.documentNumber': 'O número do documento é obrigatório',
  'clients.validation.documentFormat': 'O número do documento não segue o formato do tipo escolhido',
  'clients.validation.birthDateFuture': 'A data de nascimento não pode ser futura',
  'clients.validation.address': 'O endereço é obrigatório',
  'clients.validation.city': 'A cidade é obrigatória',
  'clients.validation.phone': 'O celular é obrigatório',
  'clients.validation.phoneFormat': 'O número de celular não é válido',
  'clients.validation.commentMax': 'O comentário permite até 500 caracteres',
  'clients.searchPlaceholder': 'Buscar por documento, nome, sobrenome ou apelido',
  'clients.search': 'Buscar',
  'clients.allRoutes': 'Ver todas as rotas',
  'clients.selectRouteOrAll': 'Selecione uma rota ou marque «Ver todas as rotas».',
  'clients.columnRoute': 'Rota',
  'clients.columnClient': 'Cliente',
  'clients.columnEmail': 'E-mail',
  'clients.columnDocument': 'Número do documento',
  'clients.columnOptions': 'Opções',
  'clients.listEmpty': 'Nenhum cliente corresponde ao filtro.',
  'clients.toggleStatus': 'Alterar estado de {{nombre}}',
  'clients.statusConfirmTitle': 'Alterar estado do cliente',
  'clients.statusConfirm': 'Deseja alterar o estado do cliente {{nombre}}? O histórico será mantido.',
  'clients.statusConfirmNew': 'Passará a {{estado}}.',
  'clients.statusConfirmAction': 'Alterar estado',
  'clients.statusChanged': 'O estado de «{{nombre}}» agora é {{estado}}.',
  'clients.statusError': 'Não foi possível alterar o estado do cliente.',
  'profiles.module.clientes': 'Clientes',
  'profiles.list.searchPlaceholder': 'Ex.: Nome',
  'profiles.list.search': 'Buscar',
  'profiles.list.showActive': 'Ver ativos',
  'profiles.list.showInactive': 'Ver inativos',
  'profiles.list.noStatusSelected': 'Marque «Ver ativos» ou «Ver inativos» para ver perfis.',
  'profiles.list.colEdit': 'Editar',
  'profiles.list.colCode': 'Código',
  'profiles.list.colName': 'Nome',
  'profiles.list.colUsers': 'Usuários',
  'profiles.list.colStatus': 'Estado',
  'profiles.list.edit': 'Editar perfil',
  'profiles.list.editProfile': 'Editar o perfil {{nombre}}',
  'profiles.list.statusOf': 'Estado de {{nombre}}: {{estado}}',
  'profiles.list.statusVisualHint': 'Somente visual: o estado é alterado ao editar o perfil.',
  'profiles.list.showing': 'Mostrando {{desde}} a {{hasta}} de {{total}} registros',
  'profiles.list.pagination': 'Paginação de perfis',
  'profiles.list.legend':
    'O toggle de Estado é somente visual. O estado é alterado em Editar, com confirmação. Não é possível desativar um perfil com usuários atribuídos.',
  'profiles.list.empty': 'Nenhum perfil corresponde à busca.',
  'profiles.editTitle': 'Editar perfil',
  'profiles.statusOfProfile': 'Estado do perfil',
  'profiles.cannotDeactivate':
    'Não é possível desativar este perfil: ele tem {{cantidad}} usuários atribuídos. Reatribua-os a outro perfil antes de desativá-lo.',
  'profiles.cannotDeactivateOne':
    'Não é possível desativar este perfil: ele tem 1 usuário atribuído. Reatribua-o a outro perfil antes de desativá-lo.',
  'profiles.usersAssigned': '{{cantidad}} usuários têm este perfil.',
  'profiles.usersAssignedOne': '1 usuário tem este perfil.',
  'profiles.confirmStatusTitle': 'Confirmar alteração de estado',
  'profiles.confirmDeactivate': 'Deseja desativar o perfil «{{nombre}}»? Ele não poderá ser atribuído a usuários enquanto estiver inativo.',
  'profiles.confirmActivate': 'Deseja ativar o perfil «{{nombre}}»?',
  'profiles.confirmStatusAction': 'Alterar estado',
  'profiles.updated': 'Perfil «{{nombre}}» atualizado com sucesso.',
  'profiles.loadingProfile': 'Carregando perfil…',
  'profiles.profileNotFound': 'O perfil não existe.',
  'profiles.backToList': 'Voltar à lista',
  'lockouts.pageTitle': 'Bloqueios do app móvel',
  'lockouts.subtitle':
    'Trabalhadores cujo app foi bloqueado. Somente o bloqueio por tentativas falhas exige que um administrador o libere; os demais são liberados pelo trabalhador com sua senha.',
  'lockouts.searchPlaceholder': 'Buscar por trabalhador ou aparelho',
  'lockouts.filterStatus': 'Estado do bloqueio',
  'lockouts.filterCause': 'Causa',
  'lockouts.allCauses': 'Todas as causas',
  'lockouts.showAll': 'Ver também os que o trabalhador libera',
  'lockouts.showAllHint':
    'Estes bloqueios (inatividade, bloqueio do celular, manual) são liberados pelo trabalhador com sua senha: são apenas informativos.',
  'lockouts.empty': 'Não há bloqueios para mostrar.',
  'lockouts.loadError': 'Não foi possível carregar os bloqueios.',
  'lockouts.deviceUnknown': 'Aparelho não identificado',
  'lockouts.column.worker': 'Trabalhador',
  'lockouts.column.route': 'Rota',
  'lockouts.column.blockedAt': 'Data e hora do bloqueio',
  'lockouts.column.cause': 'Causa',
  'lockouts.column.device': 'Modelo / dispositivo',
  'lockouts.column.location': 'Localização GPS',
  'lockouts.column.attempts': 'Histórico de tentativas',
  'lockouts.column.status': 'Estado',
  'lockouts.cause.INACTIVIDAD': 'Inatividade',
  'lockouts.cause.BLOQUEO_SO': 'Bloqueio do celular',
  'lockouts.cause.INTENTOS_FALLIDOS': 'Tentativas falhas',
  'lockouts.cause.MANUAL': 'Bloqueio manual',
  'lockouts.state.BLOQUEADO': 'Bloqueado',
  'lockouts.state.DESBLOQUEADO': 'Desbloqueado',
  'lockouts.state.codeIssued': 'Código emitido (vence {{hora}})',
  'lockouts.method.CLAVE_PROPIA': 'Senha do trabalhador',
  'lockouts.method.ADMIN_SENAL': 'Sinal do administrador',
  'lockouts.method.ADMIN_OTP': 'Código de uso único',
  'lockouts.method.ADMIN_CLAVE_RESTABLECIDA': 'Senha redefinida pelo administrador',
  'lockouts.gps.SIN_PERMISO': 'Sem permissão de localização',
  'lockouts.gps.NO_DISPONIBLE': 'Localização indisponível',
  'lockouts.gps.TIMEOUT': 'Não obtida a tempo',
  'lockouts.gps.OK': 'Sem coordenadas',
  'lockouts.location.viewMap': 'Ver no Google Maps',
  'lockouts.location.accuracy': 'Precisão ±{{m}} m',
  'lockouts.location.capturedAt': 'Obtida em {{fecha}}',
  'lockouts.attemptsCount': '{{n}} tentativas',
  'lockouts.viewHistoryOf': 'Ver histórico de tentativas de {{nombre}}',
  'lockouts.unlockDevice': 'Desbloquear dispositivo',
  'lockouts.unlockDeviceOf': 'Desbloquear o dispositivo de {{nombre}}',
  'lockouts.detail.title': 'Detalhe do bloqueio',
  'lockouts.detail.attemptsTitle': 'Histórico de tentativas',
  'lockouts.detail.noAttempts': 'Nenhuma tentativa falha foi registrada.',
  'lockouts.detail.attempt': 'Tentativa {{n}}',
  'lockouts.detail.deviceClock': 'Hora do aparelho',
  'lockouts.detail.serverClock': 'Hora do servidor',
  'lockouts.detail.authorizationTitle': 'Autorização do desbloqueio',
  'lockouts.detail.authorizedBy': 'Autorizado por',
  'lockouts.detail.authorizedAt': 'Data da autorização',
  'lockouts.detail.reason': 'Motivo',
  'lockouts.detail.signature': 'Assinatura de verificação',
  'lockouts.detail.method': 'Desbloqueado por',
  'lockouts.unlock.title': 'Desbloquear dispositivo',
  'lockouts.unlock.intro': 'Você vai autorizar o desbloqueio do app de {{nombre}}. Confirme sua identidade com sua senha.',
  'lockouts.unlock.password': 'Sua senha',
  'lockouts.unlock.passwordHelp': 'Verificação de segurança: não é armazenada.',
  'lockouts.unlock.passwordRequired': 'Digite sua senha para autorizar',
  'lockouts.unlock.mode': 'Como a autorização chega ao trabalhador',
  'lockouts.unlock.modeSignal': 'Sinal ao app: libera sozinho em segundos',
  'lockouts.unlock.modeCode': 'Código de uso único: eu o dito ao trabalhador',
  'lockouts.unlock.reason': 'Motivo do desbloqueio',
  'lockouts.unlock.reasonRequired': 'O motivo é obrigatório',
  'lockouts.unlock.reasonMin': 'O motivo deve ter pelo menos 3 caracteres',
  'lockouts.unlock.note':
    'Desbloquear não altera a senha: o trabalhador recupera suas 3 tentativas. Se a esqueceu, redefina-a em Usuários.',
  'lockouts.unlock.confirm': 'Desbloquear',
  'lockouts.unlock.unlocking': 'Verificando…',
  'lockouts.unlock.error': 'Não foi possível desbloquear o dispositivo.',
  'lockouts.unlock.signalSent': 'Pronto: o app de {{nombre}} será desbloqueado em alguns segundos.',
  'lockouts.unlock.codeTitle': 'Código de desbloqueio',
  'lockouts.unlock.codeIntro': 'Dite-o a {{nombre}}. É válido até às {{hora}}.',
  'lockouts.unlock.codeLabel': 'Código de 6 dígitos',
  'lockouts.unlock.codeOnce': 'Este código é mostrado apenas uma vez e serve para um único desbloqueio. Se o perder, emita outro.',
  'lockouts.unlock.copy': 'Copiar código',
  'lockouts.unlock.copied': 'Código copiado',
  'profiles.module.bloqueos': 'Bloqueios do app',
  'profiles.action.bloqueos.desbloquear': 'Desbloquear dispositivos',
  'activityLog.moduleBloqueos': 'Bloqueios do app',
  'mainDashboard.title': 'Desempenho da rota',
  'mainDashboard.routeFilter': 'Filtro de rota',
  'mainDashboard.allRoutes': 'Todas as rotas',
  'mainDashboard.routesLoadError': 'Não foi possível carregar as rotas.',
  'mainDashboard.noRoutesVisible': 'Você não tem rotas visíveis.',
  'mainDashboard.boxFilter': 'Filtro de caixa',
  'mainDashboard.selectBox': 'Selecione uma caixa',
  'mainDashboard.selectRouteFirst': 'Escolha primeiro uma rota',
  'mainDashboard.boxesLoadError': 'Não foi possível carregar as caixas da rota.',
  'mainDashboard.noBoxes': 'Esta rota ainda não tem caixas.',
  'mainDashboard.actions': 'Mais ações',
  'mainDashboard.seeMoreBoxes': 'Ver mais caixas',
  'mainDashboard.openNewBox': 'Abrir nova caixa',
  'mainDashboard.createExpense': 'Criar despesa',
  'mainDashboard.createIncome': 'Criar receita',
  'mainDashboard.actionUnavailable': 'Disponível quando existir o endpoint web para criá-lo na caixa de outra pessoa (US-004).',
  'mainDashboard.uploadPortfolio': 'Enviar carteira',
  'mainDashboard.refresh': 'Atualizar',
  'mainDashboard.tabsLabel': 'Desempenho da rota',
  'mainDashboard.tabSummary': 'Resumo',
  'mainDashboard.tabDetails': 'Detalhes',
  'mainDashboard.selectBoxFirst': 'Escolha uma caixa para ver seu resumo.',
  'mainDashboard.panelCashTitle': 'Caixa Final',
  'mainDashboard.entriesGroup': 'Entradas',
  'mainDashboard.exitsGroup': 'Saídas',
  'mainDashboard.initialCash': 'Caixa Inicial',
  'mainDashboard.collection': 'Cobrança',
  'mainDashboard.collectionTooltip': 'Cobrança de Rota + Cobrança Adicional',
  'mainDashboard.income': 'Receitas',
  'mainDashboard.totalSales': 'Total de Vendas',
  'mainDashboard.expenses': 'Despesas',
  'mainDashboard.withdrawals': 'Retiradas',
  'mainDashboard.finalCashResult': 'Caixa Final',
  'mainDashboard.summaryLoadError': 'Não foi possível carregar o resumo da caixa.',
  'mainDashboard.cash': 'Dinheiro',
  'mainDashboard.transfer': 'Transferência eletrônica',
  'mainDashboard.expandBreakdown': 'Ver detalhamento de {{label}}',
  'mainDashboard.collapseBreakdown': 'Ocultar detalhamento de {{label}}',
  'mainDashboard.panelPerformanceTitle': 'Desempenho (Cobrança)',
  'mainDashboard.expectedCollection': 'Pretendido',
  'mainDashboard.clientsToCollect': 'Clientes a cobrar',
  'mainDashboard.additionalCollection': 'Cobrança Adicional',
  'mainDashboard.complianceRate': '% de Cumprimento',
  'mainDashboard.unscheduledClients': 'Clientes Não Programados',

  'mainDashboard.details.loadError': 'Não foi possível carregar a informação.',
  'mainDashboard.details.emptyMessage': 'Não há movimentos registrados.',
  'mainDashboard.details.columnClient': 'Cliente',
  'mainDashboard.details.columnPhone': 'Telefone',
  'mainDashboard.details.columnFinalValue': 'Valor Final',
  'mainDashboard.details.columnPaymentValue': 'Valor do Pagamento',
  'mainDashboard.details.columnBalance': 'Saldo',
  'mainDashboard.details.columnFrequency': 'Frequência',
  'mainDashboard.details.columnSaleDate': 'Data da Venda',
  'mainDashboard.details.columnDays': 'Dias de Atraso / Decorridos',
  'mainDashboard.details.columnId': 'ID',
  'mainDashboard.details.columnDescription': 'Descrição',
  'mainDashboard.details.columnComment': 'Comentário',
  'mainDashboard.details.columnAmount': 'Valor',
  'mainDashboard.details.columnDate': 'Data',
  'mainDashboard.details.columnImages': 'Imagens',
  'mainDashboard.details.columnDestination': 'Destino',
  'mainDashboard.details.collectedTitle': 'Cobranças',
  'mainDashboard.details.unsyncedTitle': 'Não Sincronizados',
  'mainDashboard.details.incomeTitle': 'Receitas',
  'mainDashboard.details.expensesTitle': 'Despesas',
  'mainDashboard.details.withdrawalsTitle': 'Retiradas',
  'mainDashboard.details.viewImages': 'Ver imagens ({{n}})',
  'mainDashboard.details.imagesTitle': 'Comprovantes',

  'movementTypes.moduleTitle': 'Tipos de movimentos',
  'movementTypes.tabNew': 'Tipo de Movimento',
  'movementTypes.tabHistory': 'Histórico de Movimentos',

  'movementTypes.createTitle': 'Criar Tipo de Movimento',
  'movementTypes.type': 'Tipo de Movimento',
  'movementTypes.typeIncome': 'Receitas',
  'movementTypes.typeExpense': 'Despesas',
  'movementTypes.typeWithdrawal': 'Retiradas',
  'movementTypes.country': 'País',
  'movementTypes.countryPlaceholder': 'Selecione um país',
  'movementTypes.countriesLoadError': 'Não foi possível carregar os países.',
  'movementTypes.name': 'Nome',
  'movementTypes.namePlaceholder': 'Ex.: Gasolina Moto',
  'movementTypes.observation': 'Observação',
  'movementTypes.observationPlaceholder': 'Ex.: Despesa de combustível somente para motos',
  'movementTypes.observationHelp': 'Campo opcional.',
  'movementTypes.saving': 'Salvando...',
  'movementTypes.created': 'O movimento «{{nombre}}» foi criado.',
  'movementTypes.createError': 'Não foi possível criar o tipo de movimento.',
  'movementTypes.validation.type': 'Selecione o tipo de movimento.',
  'movementTypes.validation.country': 'Selecione um país.',
  'movementTypes.validation.name': 'O nome é obrigatório.',

  'movementTypes.searchPlaceholder': 'Buscar por observação...',
  'movementTypes.filterCountry': 'Filtro de país',
  'movementTypes.filterType': 'Filtro de tipo',
  'movementTypes.filterStatus': 'Filtro de estado',
  'movementTypes.replicate': 'Replicar para outro país',
  'movementTypes.replicateTitle': 'Replicar para outro país',
  'movementTypes.replicateSourceCountry': 'País de origem',
  'movementTypes.replicateTargetCountry': 'País de destino',
  'movementTypes.replicateSelectAll': 'Selecionar todos',
  'movementTypes.replicateSelectRow': 'Selecionar {{nombre}}',
  'movementTypes.replicateAlreadyExists': 'Já existe em {{destino}} - será ignorado',
  'movementTypes.replicateSelectedCount': '{{seleccionados}} selecionados - {{omitidos}} ignorados',
  'movementTypes.replicateEmptyHint': 'Selecione o país de origem e o país de destino para ver os movimentos a replicar.',
  'movementTypes.replicateNoItems': 'O país de origem não tem tipos de movimento para replicar.',
  'movementTypes.replicateLoadError': 'Não foi possível carregar a pré-visualização.',
  'movementTypes.replicateAction': 'Replicar',
  'movementTypes.replicateConfirmTitle': 'Confirmar replicação',
  'movementTypes.replicateConfirmDescription': 'Você vai criar {{count}} movimento(s) em {{destino}}. Continuar?',
  'movementTypes.replicateSuccess': '{{replicados}} replicados, {{omitidos}} ignorados.',
  'movementTypes.replicateError': 'Não foi possível concluir a replicação.',
  'movementTypes.downloadExcel': 'Baixar Excel',
  'movementTypes.exporting': 'Baixando...',
  'movementTypes.exportError': 'Não foi possível baixar o arquivo.',
  'movementTypes.listEmpty': 'Não há tipos de movimento registrados.',
  'movementTypes.columnCountry': 'País',
  'movementTypes.columnName': 'Nome',
  'movementTypes.columnObservation': 'Observação',
  'movementTypes.columnType': 'Tipo',
  'movementTypes.columnIncome': 'Receitas',
  'movementTypes.columnExpense': 'Despesas',
  'movementTypes.columnWithdrawal': 'Retiradas',
  'movementTypes.columnActions': 'Ações',
  'movementTypes.toggleStatus': 'Alterar estado de {{nombre}}',
  'movementTypes.activateConfirmTitle': 'Ativar movimento',
  'movementTypes.activateConfirm': 'Ativar «{{nombre}}»? Ficará disponível imediatamente no celular.',
  'movementTypes.deactivateConfirmTitle': 'Desativar movimento',
  'movementTypes.deactivateConfirm': 'Desativar «{{nombre}}»? Deixará de estar disponível no celular, mas continuará visível no Histórico.',
  'movementTypes.activated': '«{{nombre}}» foi ativado.',
  'movementTypes.deactivated': '«{{nombre}}» foi desativado.',
  'movementTypes.statusChangeError': 'Não foi possível alterar o estado do movimento.'
};

export default pt;
